import { ElementRef, Directive, NgZone } from '@angular/core';
import { DraggableDirective } from '../../../../../kendo/kendo-angular-layout/common/draggable.directive';

/**
 * @hidden
 */
@Directive({
  standalone: false,
    outputs: ['kendo.press', 'kendo.drag', 'kendo.release'], /* eslint-disable-line */
  selector: '[kendoLayoutDraggable]',
})
export class TiDraggableDirective extends DraggableDirective {
  constructor(zone: NgZone, element: ElementRef) {
    super(zone, element);
  }
}
